/**
 * @desc 列表
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(body: defs.mns.MessageEventRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/messageEvent/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
